import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LoadingOverlay from '../../shared/components/LoadingOverlay';
import { useDocumentTitle } from '../../shared/hooks/useDocumentTitle';

/**
 * SignoutCallbackPage - Callback stranica nakon eID logout-a
 * 
 * Ova komponenta se poziva nakon što eID server završi logout proces.
 * Prikazuje poruku i redirektuje korisnika na početnu stranicu.
 * 
 * Ruta: /signout-callback-oidc
 */
const SignoutCallbackPage = () => {
  const navigate = useNavigate();
  const [showLoader, setShowLoader] = useState(true);
  
  // Postavi dinamički title
  useDocumentTitle('Одјава - Партнерство за отворену управу');

  useEffect(() => {
    // Automatski redirektuj nakon 2 sekunde
    const timer = setTimeout(() => {
      setShowLoader(false);
      navigate('/');
    }, 2000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <LoadingOverlay
      isLoading={showLoader}
      title="Успешно сте се одјавили"
      message="Хвала што сте користили Партнерство за отворену управу"
      steps={['Преусмеравање на почетну страницу...']}
    />
  );
};

export default SignoutCallbackPage;

